export default function updateClient(this, client) {
  const { name } = this.$route;

  this.repair_client = client;
  if (name !== 'repair-form-add') this.data_repair.client_id = client.id;
}
